if (document.querySelector("[data-navigation-menu]")) {
  // DOM elements
  var navigationMenu = document.querySelector("[data-navigation-menu]");
  var navigationNavbar = navigationMenu.querySelector("[data-navigation-navbar]");
  var navigationBgClouds = navigationMenu.querySelectorAll("[data-navigation-cloud]");
  var navigationCloudsContainer = navigationMenu.querySelector("[data-navigation-clouds-container]");
  var toggleMenuButton = document.querySelector("[data-toggle-nav-menu-btn]");
  var cloudTemplate = navigationMenu.querySelector("[data-navigation-cloud-template]");
  var productsMenu = navigationMenu.querySelector("[data-navigation-products-menu]");
  var productsMenuButton = navigationMenu.querySelector("[data-navigation-products-menu-button]");
  var menuDrawerContainer = document.querySelector("#Details-menu-drawer-container");

  // animating clouds
  var fadeInDurationMainMenu = parseInt(getCSSPropertyValueFromRoot("--NAVBAR-fade-in-transition-duration-main-menu"));
  var fadeInDurationProductsMenu = parseInt(getCSSPropertyValueFromRoot("--NAVBAR-fade-in-transition-duration-products-menu"));
  var slideInBiggestDuration = parseInt(getCSSPropertyValueFromRoot("--NAVBAR-slide-in-biggest-transition-duration"));
  var productsMenuOpeningAnimationInProgress = false;
  var previousVerticalScrollPosition = 0;

  toggleMenuButton.addEventListener("click", () => {
    if (toggleMenuButton.getAttribute('aria-expanded') == 'true') {
      closeMenuPanel();
    } else {
      openMenuPanel();
      setTimeout(() => {
        toggleProductsMenu();
      }, fadeInDurationProductsMenu + 1);
    }
  });

  // close menu when clicking outside of the menu
  document.addEventListener("click", (event) => {
    if (window.innerWidth >= 1300) {
      if (!event.target.closest("[data-navigation-menu-wrapper]")) return;

      const isClickInsideMenuList = event.target.closest("[data-navigation-products-menu], .navigation-menu__list");
      const isMenuOpen = navigationMenu.classList.contains("show");
      
      if (!isClickInsideMenuList && isMenuOpen) {
        closeMenuPanel();
        setTimeout(() => {
          toggleMenuButton.setAttribute('aria-expanded', 'false');
          menuDrawerContainer.classList.remove("menu-opening");
          menuDrawerContainer.removeAttribute("open");
        }, slideInBiggestDuration / 4 + fadeInDurationMainMenu / 3);
      }
    }
  });

  productsMenuButton && productsMenuButton.addEventListener("click", () => {
    toggleProductsMenu();
  });

  // positioning clouds
  var targetCoveragePercentage = 2.2;
  var maxOverlapRatio = 0.1;

  var CLOUD_IMAGES = [
    {
      className: "navigation-menu__bg-cloud--center",
      width: 600,
      aspectRatio: 1.98,
      imgURL: "https://cdn.shopify.com/s/files/1/1715/6045/files/nav-cloud-center.webp?v=1689976951"
    },
    {
      className: "navigation-menu__bg-cloud--top-left",
      width: 850,
      aspectRatio: 2.32,
      imgURL: "https://cdn.shopify.com/s/files/1/1715/6045/files/nav-cloud-top-left.webp?v=1689976952"
    },
    {
      className: "navigation-menu__bg-cloud--top-right",
      width: 1100,
      aspectRatio: 2.45,
      imgURL: "https://cdn.shopify.com/s/files/1/1715/6045/files/nav-cloud-top-right.webp?v=1689875849"
    },
    {
      className: "navigation-menu__bg-cloud--bottom-left",
      width: 900,
      aspectRatio: 2.1,
      imgURL: "https://cdn.shopify.com/s/files/1/1715/6045/files/nav-cloud-bottom-left.webp?v=1689875849"
    },
    {
      className: "navigation-menu__bg-cloud--bottom-right",
      width: 950,
      aspectRatio: 1.98,
      imgURL: "https://cdn.shopify.com/s/files/1/1715/6045/files/nav-cloud-bottom-right.webp?v=1689856922"
    },
  ];

  function randomizeClouds() {
    let currentCoverage = 0;
    const skyArea = navigationCloudsContainer.clientWidth * navigationCloudsContainer.clientHeight;
    const targetCoverage = skyArea * targetCoveragePercentage;
  
    navigationCloudsContainer.innerHTML = '';
  
    // console.log(navigationCloudsContainer.clientWidth, navigationCloudsContainer.clientHeight);
    while (currentCoverage < targetCoverage) {
      const cloudFragment = cloudTemplate.content.cloneNode(true);
  
      const randomImageObj = CLOUD_IMAGES[Math.floor(Math.random() * CLOUD_IMAGES.length)];
  
      const cloudWrapper = cloudFragment.querySelector("[data-navigation-cloud]");
      cloudWrapper.classList.add(randomImageObj.className);
      cloudWrapper.style.width = `${randomImageObj.width}px`;
      cloudWrapper.style.height = `${randomImageObj.width / randomImageObj.aspectRatio}px`;
  
      const cloudImg = cloudFragment.querySelector("[data-navigation-cloud-image]");
      cloudImg.src = randomImageObj.imgURL;
      cloudImg.style.transform = `translateX(calc(-140% - ${navigationCloudsContainer.clientWidth}px))`;
  
      const cloudWidth = randomImageObj.width;
      const cloudHeight = randomImageObj.width / randomImageObj.aspectRatio;
  
      let xPos, yPos, validPosition;
  
      do {
        xPos = (Math.random() * (navigationCloudsContainer.clientWidth + cloudWidth)) - (cloudWidth / 2);
        yPos = (Math.random() * (navigationCloudsContainer.clientHeight + cloudHeight)) - (cloudHeight / 2);
  
        validPosition = true;
        const clouds = document.querySelectorAll("[data-navigation-cloud]");
  
        for (const existingCloud of clouds) {
          const cloudRect = {
            left: xPos,
            top: yPos,
            right: xPos + cloudWidth,
            bottom: yPos + cloudHeight,
            width: cloudWidth,
            height: cloudHeight
          };
          const existingCloudRect = existingCloud.getBoundingClientRect();
          const maxOverlapArea = maxOverlapRatio * cloudWidth * cloudHeight;

          const overlapArea = calculateOverlapPercentage(cloudRect, existingCloudRect);
  
          if (overlapArea > maxOverlapArea) {
            validPosition = false;
            break;
          }
        }
      } while (!validPosition);
  
      cloudWrapper.style.left = `${xPos}px`;
      cloudWrapper.style.top = `${yPos}px`;

      navigationCloudsContainer.appendChild(cloudFragment);
  
      // Calculate coverage
      const cloudRect = cloudWrapper.getBoundingClientRect();
      const visibleWidth = Math.max(0, Math.min(cloudRect.right, navigationCloudsContainer.clientWidth) - Math.max(cloudRect.left, 0));
      const visibleHeight = Math.max(0, Math.min(cloudRect.bottom, navigationCloudsContainer.clientHeight) - Math.max(cloudRect.top, 0));
      const visibleArea = visibleWidth * visibleHeight;
  
      currentCoverage += visibleArea;
    }
  }

  function applyBlurEffect() {
    const clouds = [...navigationCloudsContainer.querySelectorAll("[data-navigation-cloud]")];

    clouds.forEach((cloud, index) => {
      if (checkCloudIsOverlappedAndIsFront(cloud, index)) {
        cloud.classList.add('blur-intensity-300');

        applyBlurEffectsBehindFrontCloud(cloud);
      }
    });
  }

  function applyBlurEffectsBehindFrontCloud(cloud) {
    const clouds = [...navigationCloudsContainer.querySelectorAll("[data-navigation-cloud]")];

    let secondBiggerIndex = -1;
    let biggerIndex = -1;

    clouds.forEach((currentCloud, currentCloudIndex) => {
      if (currentCloud === cloud) return;

      if (checkElementsOverlap(cloud, currentCloud)) {
        if (currentCloudIndex > biggerIndex) {
          secondBiggerIndex = biggerIndex;
          biggerIndex = currentCloudIndex;
        }
      }
    });

    if (biggerIndex !== -1) {
      clouds[biggerIndex].classList.add('blur-intensity-200');
    }
    if (secondBiggerIndex !== -1) {
      clouds[secondBiggerIndex].classList.add('blur-intensity-100');
    }
  }

  function checkCloudIsOverlappedAndIsFront(cloud, index) {
    const clouds = [...navigationCloudsContainer.querySelectorAll("[data-navigation-cloud]")];
    let cloudOverlapFrontElem = true;

    clouds.forEach((currentCloud, currentCloudIndex) => {
      if (currentCloud === cloud) return;

      if (checkElementsOverlap(cloud, currentCloud)) {
        if (currentCloudIndex > index) {
          cloudOverlapFrontElem = false;
        }
      }
    });

    if (cloudOverlapFrontElem) {
      return true;
    }

    return false;
  }

  function checkElementsOverlap(elem1, elem2) {
    const rect1 = elem1.getBoundingClientRect();
    const rect2 = elem2.getBoundingClientRect();

    // Check if the two rectangles overlap
    const overlap = !(rect1.right < rect2.left ||
      rect1.left > rect2.right ||
      rect1.bottom < rect2.top ||
      rect1.top > rect2.bottom);

    return overlap;
  }

  function calculateOverlapPercentage(rect1, rect2) {
    // Calculate the overlapping area
    const overlapWidth = Math.min(rect1.right, rect2.right) - Math.max(rect1.left, rect2.left);
    const overlapHeight = Math.min(rect1.bottom, rect2.bottom) - Math.max(rect1.top, rect2.top);
    const overlapArea = Math.max(0, overlapWidth) * Math.max(0, overlapHeight);
  
    // Calculate the total area of both elements
    const totalArea = rect1.width * rect1.height + rect2.width * rect2.height;
  
    // Calculate the overlap percentage
    const overlapPercentage = overlapArea / totalArea * 100;

    return overlapPercentage;
  }

  // let previousWindowWidth = window.innerWidth;
  // window.addEventListener("resize", () => {
  //   if (previousWindowWidth < 1300 && window.innerWidth >= 1300) {
  //     if (productsMenu.style.display === "none") {
  //       productsMenu.style.display = "";
  //       closeProductsMenuLargerScreens();
  //     } else {
  //       productsMenu.style.display = "";
  //       openProductsMenuLargerScreens();
  //     }
  //   }

  //   if (previousWindowWidth > 1300 && window.innerWidth <= 1300) {
  //     if (productsMenu.classList.contains("show")) {
  //       $(productsMenu).slideDown(fadeInDurationProductsMenu);
  //     } else {
  //       $(productsMenu).slideUp(fadeInDurationProductsMenu);
  //     }
  //   }

  //   previousWindowWidth = window.innerWidth;
  // });

  function openMenuPanel() {
    /* // store current scroll position
    previousVerticalScrollPosition = window.scrollY;
    // disable scrolling
    document.body.style.overflow = "hidden";
    // disable smooth scrolling
    document.body.style.scrollBehavior = "auto"; */

    // close products menu if it's opened
    if (window.innerWidth >= 1300 && productsMenu) closeProductsMenuLargerScreens();
    if (window.innerWidth < 1300 && productsMenu) $(productsMenu).slideUp(fadeInDurationProductsMenu);

    navigationMenu.classList.add("show");

    setTimeout(() => {
      navigationMenu.classList.add("fade-in");
      navigationNavbar.classList.add("fade-in");

      /* randomizeClouds();
      applyBlurEffect();
      navigationBgClouds = navigationMenu.querySelectorAll("[data-navigation-cloud]");
      navigationBgClouds.forEach(cloud => {
        cloud.classList.add("slide-in");
      }); */
    }, 0);

    // setTimeout(() => {
    //   navigationNavbar.classList.add("fade-in");
    // }, slideInBiggestDuration / 4 * 3);
  }

  function closeMenuPanel() {
    /* // enable scrolling
    document.body.style.overflow = "";
    // enable smooth scrolling
    document.body.style.scrollBehavior = "";
    // restore previous scroll position
    window.scrollTo(0, previousVerticalScrollPosition); */

    navigationNavbar.classList.remove("fade-in");
    /* navigationBgClouds.forEach(cloud => {
      cloud.classList.remove("slide-in");
    }); */

    setTimeout(() => {
      navigationMenu.classList.remove("fade-in");
    }, slideInBiggestDuration / 4);

    setTimeout(() => {
      navigationMenu.classList.remove("show");
    }, slideInBiggestDuration / 4 + fadeInDurationMainMenu / 3);
  }

  function closeProductsMenu() {
    navigationMenu.dataset.productsMenu = "";

    if (window.innerWidth > 1300) {
      closeProductsMenuLargerScreens();
    } else {
      $(productsMenu).slideToggle(fadeInDurationProductsMenu);
    }

    setTimeout(() => {
      productsMenuOpeningAnimationInProgress = false;
    }, fadeInDurationProductsMenu);
  }

  function closeProductsMenuLargerScreens() {
    productsMenu.classList.remove("animate-in");
      
    setTimeout(() => {
      productsMenu.classList.remove("show");
    }, fadeInDurationProductsMenu);
  }

  function openProductsMenu() {
    navigationMenu.dataset.productsMenu = "open";

    if (window.innerWidth > 1300) {
      openProductsMenuLargerScreens();
    } else {
      $(productsMenu).slideToggle(fadeInDurationProductsMenu);
    }

    setTimeout(() => {
      productsMenuOpeningAnimationInProgress = false;
    }, fadeInDurationProductsMenu);
  }

  function openProductsMenuLargerScreens() {
    productsMenu.classList.add("show");
      
    setTimeout(() => {
      productsMenu.classList.add("animate-in");
    }, 0);
  }

  function toggleProductsMenu() {
    if (productsMenuOpeningAnimationInProgress) return;

    productsMenuOpeningAnimationInProgress = true;
    if (productsMenu.classList.contains("animate-in")) {
      closeProductsMenu(); return;
    }

    openProductsMenu();
  }
}